import React from "react";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import UnapprovedCreditNoteTable from "../unapprovedCreditNotes/components/UnapprovedCreditNoteTable";
import PostedCreditNotesTable from "../commercialDocuments/components/PostedCreditNotesTable";
import HeaderContent from "../../components/layout/components/HeaderContent";
import ExportCommercialDocumentButton from "../commercialDocuments/components/ExportCommercialDocumentButton";
import { availableOnlySuperAdmin } from "utils/validation";

const CreditNoteList = () => {
  const breadcrumb = [{ link: "/creditNotes", title: "Credit Notes" }];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Credit Notes"
        isNotHaveSchoolFilter
      />
      <SanitizedGrid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="h6">Financial Information</Typography>
        </Grid>
        <Grid item xs={6}>
          {availableOnlySuperAdmin() && (
            <ExportCommercialDocumentButton documentType="CreditNote" />
          )}
        </Grid>

        <Grid item xs={8}>
          <Typography variant="h6">Unapproved Credit Notes</Typography>
        </Grid>
        <Grid item xs={4}></Grid>

        <Grid item xs={12}>
          <UnapprovedCreditNoteTable />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Approved Credit Notes</Typography>
        </Grid>

        <Grid item xs={12}>
          <PostedCreditNotesTable />
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default CreditNoteList;
